import React from "react";
import classNames from "classnames";
import { FaCheck } from "react-icons/fa";
import IconText from "../../IconText/IconText";
import "./Feature.scss";
import { withDefaults } from "../../../utils/withDefaults";

export interface FeatureProps {
  featureName?: string;
  isBasicFeature?: boolean;
  isPremiumList?: boolean;
}

export default function Feature(incomingProps: FeatureProps) {
  const props = withDefaults(incomingProps, featureDefaultProps);

  const isEnabledClassName =
    props.isBasicFeature || props.isPremiumList ? "enabled" : "disabled";

  return (
    <IconText
      wrapperClassName={classNames(
        "feature",
        props.isBasicFeature ? "basic" : "premium"
      )}
    >
      <div>
        <FaCheck
          aria-label={`checkmark ${isEnabledClassName}`}
          className={isEnabledClassName}
        />
      </div>
      <div>
        <span className={isEnabledClassName}>{props.featureName}</span>
      </div>
    </IconText>
  );
}

const featureDefaultProps = {
  featureName: "",
  isBasicFeature: true,
  isPremiumList: false
};
